import { render, staticRenderFns } from "./aiclass_member_xufei.vue?vue&type=template&id=d7cbdbe4&scoped=true"
import script from "./aiclass_member_xufei.vue?vue&type=script&lang=js"
export * from "./aiclass_member_xufei.vue?vue&type=script&lang=js"
import style0 from "./aiclass_member_xufei.vue?vue&type=style&index=0&id=d7cbdbe4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7cbdbe4",
  null
  
)

export default component.exports